import type {
    ExportForDatoQuery,
    GetDatoExportLogsResponseBody,
    GetTotalWeightLossResponseBody,
} from '@common/interfaces/api/bariatricsApi';
import type { PagerParameters } from '@common/interfaces/api/queryParameters';
import { getUrlQueryParameters } from '@frontend/services/api/queryParameterUtils';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/bariatrics';

export async function getDatoExportLogs(
    query: PagerParameters,
    signal: AbortSignal
): Promise<GetDatoExportLogsResponseBody> {
    const url = getUrlQueryParameters<PagerParameters>(`${baseUrl}/exports/dato/logs`, query);
    const result = await fetchJson({ method: 'GET', signal, url });

    return result?.json;
}

export async function getTotalWeightLoss(
    processId: string,
    signal: AbortSignal
): Promise<GetTotalWeightLossResponseBody> {
    const url = `${baseUrl}/processes/${processId}/totalWeightLoss`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result?.json;
}

export function exportForDato(query: ExportForDatoQuery): void {
    const url = getUrlQueryParameters<ExportForDatoQuery>(`${baseUrl}/exports/dato`, query);
    window.open(url);
}
